import tw from 'twin.macro'
import React, { useContext } from 'react'
import { OnboardingsContext } from '../onboardings/Onboardings.context'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'
import { OnboardingsTableContext } from '../onboardings-table/OnboardingsTable.context'
import { GridColumnsSelect } from 'src/components/shared/grid/grid-columns-select/GridColumnsSelect'
import { OnboardingStatus } from 'src/constants/onboarding/enums'
import { OnboardingInvitedAtSelect } from '../shared/OnboardingInvitedAtSelect'
import { OnboardingTagsSelect } from '../shared/OnboardingTagsSelect'

interface Props {
  selectedStatus: OnboardingStatus
}

export const OnboardingsHeader = ({ selectedStatus }: Props) => {
  const { setSearchQuery, searchQuery } = useContext(OnboardingsContext)
  const { hasPermission } = useCheckPermissions()
  const {
    columnsConfig,
    columnVisibilityModel,
    pinnedColumns,
    lockedColumns,
    onToggleColumnVisibility,
    onColumnVisibilityModelChange,
    onPinColumn,
    onUnpinColumn,
  } = useContext(OnboardingsTableContext)

  return (
    <div
      css={tw`flex flex-row items-center gap-4 bg-white px-4 py-3 border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      {columnsConfig.length > 0 && (
        <GridColumnsSelect
          columnsConfig={columnsConfig}
          columnVisibilityModel={columnVisibilityModel}
          pinnedColumns={pinnedColumns}
          lockedColumns={lockedColumns}
          onToggleColumnVisibility={onToggleColumnVisibility}
          onColumnVisibilityModelChange={onColumnVisibilityModelChange}
          onPinColumn={onPinColumn}
          onUnpinColumn={onUnpinColumn}
        />
      )}
      <TableSearch
        searchQuery={searchQuery}
        onChangeSearchQuery={setSearchQuery}
        inputDataTestId="contractors-onboarding-list-search-input"
        clearButtonDataTestId="contractors-onboarding-list-search-clear-btn"
      />
      {hasPermission(UserPermission.TagsView) && <OnboardingTagsSelect />}
      {selectedStatus !== OnboardingStatus.Failed && <OnboardingInvitedAtSelect />}
    </div>
  )
}
